export default "__VITE_PUBLIC_ASSET__7551fa4d__"